module.exports = __webpack_public_path__ + "img/1378862255.fb520096.jpg";